import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IForcePasswordUpdateParams {
  siteUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateOnSiteUsersRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdateOnSiteUsers', params);
  }
}
